import PropTypes from 'prop-types';
import React from 'react';

import { IconLogo } from '$partials/icons';
import { IconArrowRight } from '$partials/icons/index.js';

const FundItem = ({
    className = '',
    page = {},
    showCta = true
}) => {
    let hoverColour = null;

    switch (page?.branding) {
    case 'SOLAR':
        hoverColour = 'solar-button';
        break;
    case 'LOCAL_GLOBE':
        hoverColour = 'local_globe-button';
        break;
    case 'LATITUDE':
        hoverColour = 'latitude-button';
        break;
    case 'BASECAMP':
        hoverColour = 'basecamp-button';
        break;
    case 'PHOENIX_COURT_WORKS':
        hoverColour = 'phoenix_court_works-button';
        break;
    default:
        hoverColour = 'phoenix_court-button';
        break;
    }

    return (
        <div className={`bg-white flex flex-col justify-between sm:h-full rounded-s-lg sm:rounded-lg px-25 py-30 sm:px-20 sm:pt-30 sm:pb-40 md:px-30 expand-interaction ${className}`}>
            <div className='flex gap-1/12 h-full'>
                <span
                    aria-hidden={true}
                    className='block'>
                    <IconLogo
                        branding={page?.branding} />
                </span>
                <div className='flex flex-col'>
                    <div>
                        {page?.title &&
                            <p className='type-style-4'>
                                {page?.title}
                            </p>
                        }
                    </div>
                    {page?.headline && (
                        <div className='mt-12'>
                            <p>
                                {page?.headline}
                            </p>
                        </div>
                    )}

                    {/* Spacer */}
                    <div className='flex-1'></div>
                    {showCta && (
                        <div className='mt-20 md:mt-30 arrow-button'>
                            <a
                                className={`${hoverColour} px-12 py-5 sm:py-8 rounded-3xl h-fit`}
                                href={page?.url}
                                rel='noopener noreferrer'
                                target='_blank'>
                                <span className='type-style-7 z2 relative inline-flex items-center gap-5'>
                                    {'Learn more'}
                                    <IconArrowRight />
                                </span>
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    className: PropTypes.string,
    page: PropTypes.shape({
        url: PropTypes.string,
        title: PropTypes.string,
        headline: PropTypes.string,
        branding: PropTypes.string,
    }),
    showCta: PropTypes.bool,
};

FundItem.propTypes = propTypes;

export default FundItem;
